// extracted by mini-css-extract-plugin
export default {"addedCard":"AddedCard_addedCard__KnMgT","radio":"AddedCard_radio__Myhsm","checkmark":"AddedCard_checkmark__mOMHe","deleteBtn":"AddedCard_deleteBtn__U3U+j"};